import { Injectable, Output, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';



import { ServerConn } from '../serverConn.service';

@Injectable()
export class WorksPendingService {

    // data: any[] = [];
    data: any = {};
    length = 0;
    work: any[] = [];
    @Output()
    needUpdate: EventEmitter<any> = new EventEmitter();
    selectedCEA = '';

    constructor(private server: ServerConn) { }

    setCEA(cea) {
        this.selectedCEA = cea;
        this.needUpdate.emit(cea);
    }

    get(force = false): Observable<any> {
        if (!this.data.length || force) {
            /**
             * Retornamos un
             */
            return Observable.create(observer => {
                this.server.get(
                    'works/pending',
                    {
                        a: 'g'
                    }
                ).subscribe(
                    (res: any) => {
                        const data = (typeof res.json !== 'undefined') ? res.json() : res;
                        this.data = data;
                        observer.next(res);
                    }, // simply passing success response
                    err => { // error handling
                           observer.error(err); // passing error to the method which invoked request
                    },
                    () => observer.complete // passing onComplete event);
                );
            });
            // return data;
        } else {
            return of(this.data);
        }
    }

    getPaginated(
      filter: any,
      sort: string,
      start: number,
      limit: number,
      withDistributions: boolean = false
    ): Observable<any> {

      // if (this.server.user.level >= 7 && this.selectedCEA > '') {
      //   filter.cea = {
      //     field: 'cea',
      //     operation: '=',
      //     value: this.selectedCEA
      //   };
      // }
      if (this.server.user.level >= 7 && this.selectedCEA > '') {
        if (!filter[0]) {
          filter[0] = [];
        }
        filter[0].push({
          bitwise: '&&',
          field: 'animales_temporal.cea',
          operation: '=',
          value: this.selectedCEA
        });
      }
      // return Observable.create(observer => {
      return new Observable((observer) => {
        const params: any = {
          a: 'g',
          tblfilter: JSON.stringify(filter),
          tblorder: sort,
          tblstart: start,
          tbllimit: limit,
        };
        if (withDistributions) {
          params.with_distributions = 1;
        }
        this.server.get(
          'works/pending',
          params
        ).subscribe(
          (res: any) => {
            const data = (typeof res.json !== 'undefined') ? res.json() : res;
            this.data = data;
            observer.next(res);
          }, // simply passing success response
          err => { // error handling
            observer.error(err); // passing error to the method which invoked request
          },
          () => observer.complete // passing onComplete event);
        );
      });
    }

    getCEA(cea): Observable<any> {
        // if (!this.data.length) {
            /**
             * Retornamos todos los animales de la db
             */
            return Observable.create(observer => {
                this.server.get(
                    'works/pending',
                    {
                        a: 'g',
                        tblfilter: JSON.stringify([
                            {
                                value: cea,
                                operation: '=',
                                field: 'cea'
                            }
                        ])
                    }
                ).subscribe(
                    (res: any) => {
                        const resp = (typeof res.json !== 'undefined') ? res.json() : res;
                        this.data = resp.data;
                        this.length = resp.length;
                        console.log(resp);
                        observer.next(res);
                    }, // simply passing success response
                    err => { // error handling
                           observer.error(err); // passing error to the method which invoked request
                    },
                    () => observer.complete // passing onComplete event);
                );
            });
            // return data;
        // } else {
        //     return Observable.of(this.data);
        // }
    }

    getPending(filter: any, sort: string, start: number, limit: number): Observable<any> {
        // if (!this.data.length) {
            /**
             * Retornamos un
             */
            console.log(filter, JSON.stringify(filter), sort, start, limit);
            if (this.server.user.level >= 7 && this.selectedCEA > '') {
                filter.cea = {
                    field: 'cea',
                    operation: '=',
                    value: this.selectedCEA
                };
            }
            return Observable.create(observer => {
                this.server.get(
                    'works/pending',
                    {
                        a: 'g',
                        tblfilter: JSON.stringify(filter),
                        tblorder: sort,
                        tblstart: start,
                        tbllimit: limit
                    }
                ).subscribe(
                    (res: any) => {
                        const resp = (typeof res.json !== 'undefined') ? res.json() : res;
                        this.data = resp.data;
                        this.length = resp.length;
                        observer.next(res);
                    }, // simply passing success response
                    err => { // error handling
                           observer.error(err); // passing error to the method which invoked request
                    },
                    () => observer.complete // passing onComplete event);
                );
            });
            // return data;
        // } else {
        //     return Observable.of(this.data);
        // }
    }

    getWork(id: number): any {
        return new Observable(observer => {
            this.server.get(
                'works/pending/' + id
            ).subscribe(
                (res: any) => {
                    this.work = (typeof res.json !== 'undefined') ? res.json() : res;
                    observer.next(res);
                }, // simply passing success response
                err => { // error handling
                       observer.error(err); // passing error to the method which invoked request
                },
                () => observer.complete // passing onComplete event);
            );
        });
    }

    getSolutions(work, solution) {

      return this.server.post(
        'works/pending/solutions/info',
        {
          r: solution.accion,
          d: '{"cea": "' + work.cea + '", "fecha": "' + work.fecha + '", "trabajo": "' + work.trabajo + '", "bolo": "' + work.bolo + '"}'
        }
      );

    }

    reset() {
      this.data = [];
      this.work = [];
    }

}
